module.exports = __webpack_public_path__ + "../resources/images/hideDeletedLarge-6fcac39bc6bb799c1ca723f157fe23a6.svg";